var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_vm._v("Отчет за "+_vm._s(_vm.dateLabel)+" ["+_vm._s(_vm.appLogin)+"]")])}
var staticRenderFns = []

export { render, staticRenderFns }